var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscountTenOff(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 83.2646 79.6392",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "10% OFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_d_0_76)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.9306 71.2812V45.0994H78.8027V50.2386H67.2587V55.6079H77.665V60.7599H67.2587V71.2812H60.9306Z",
    fill: "var(--fill-0, white)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2",
    filter: "url(#filter1_d_0_76)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.372 71.2812V45.0994H55.2441V50.2386H43.7001V55.6079H54.1064V60.7599H43.7001V71.2812H37.372Z",
    fill: "var(--fill-0, white)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3",
    filter: "url(#filter2_d_0_76)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.1774 58.1903C31.1774 61.071 30.6234 63.5128 29.5154 65.5156C28.4075 67.5185 26.9075 69.0398 25.0154 70.0795C23.1319 71.1193 21.0183 71.6392 18.6745 71.6392C16.3223 71.6392 14.2044 71.1151 12.3208 70.0668C10.4373 69.0185 8.94158 67.4972 7.83363 65.5028C6.73419 63.5 6.18448 61.0625 6.18448 58.1903C6.18448 55.3097 6.73419 52.8679 7.83363 50.8651C8.94158 48.8622 10.4373 47.3409 12.3208 46.3011C14.2044 45.2614 16.3223 44.7415 18.6745 44.7415C21.0183 44.7415 23.1319 45.2614 25.0154 46.3011C26.9075 47.3409 28.4075 48.8622 29.5154 50.8651C30.6234 52.8679 31.1774 55.3097 31.1774 58.1903ZM24.7086 58.1903C24.7086 56.4858 24.4657 55.0455 23.9799 53.8693C23.5027 52.6932 22.8123 51.8026 21.9089 51.1974C21.014 50.5923 19.9359 50.2898 18.6745 50.2898C17.4217 50.2898 16.3436 50.5923 15.4402 51.1974C14.5368 51.8026 13.8421 52.6932 13.3564 53.8693C12.8791 55.0455 12.6404 56.4858 12.6404 58.1903C12.6404 59.8949 12.8791 61.3352 13.3564 62.5114C13.8421 63.6875 14.5368 64.5781 15.4402 65.1832C16.3436 65.7883 17.4217 66.0909 18.6745 66.0909C19.9359 66.0909 21.014 65.7883 21.9089 65.1832C22.8123 64.5781 23.5027 63.6875 23.9799 62.5114C24.4657 61.3352 24.7086 59.8949 24.7086 58.1903Z",
    fill: "var(--fill-0, white)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4",
    filter: "url(#filter3_d_0_76)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.2986 22.3722V20.9915C67.2986 19.9176 67.5288 18.9247 67.989 18.0128C68.4577 17.1009 69.1353 16.3679 70.0217 15.8139C70.908 15.2599 71.9904 14.983 73.2688 14.983C74.5728 14.983 75.668 15.2599 76.5543 15.8139C77.4492 16.3594 78.1225 17.0881 78.5742 18C79.0344 18.9034 79.2646 19.9006 79.2646 20.9915V22.3722C79.2646 23.446 79.0344 24.4389 78.5742 25.3509C78.114 26.2628 77.4364 26.9957 76.5415 27.5497C75.6467 28.1037 74.5558 28.3807 73.2688 28.3807C71.9734 28.3807 70.8825 28.1037 69.9961 27.5497C69.1097 26.9957 68.4364 26.2628 67.9762 25.3509C67.5245 24.4389 67.2986 23.446 67.2986 22.3722ZM71.3768 20.9915V22.3722C71.3768 22.9176 71.5089 23.4418 71.7731 23.9446C72.0458 24.4474 72.5444 24.6989 73.2688 24.6989C74.0103 24.6989 74.5089 24.456 74.7646 23.9702C75.0202 23.4759 75.1481 22.9432 75.1481 22.3722V20.9915C75.1481 20.4205 75.0245 19.8835 74.7773 19.3807C74.5387 18.8693 74.0359 18.6136 73.2688 18.6136C72.5529 18.6136 72.0586 18.8693 71.7859 19.3807C71.5131 19.8835 71.3768 20.4205 71.3768 20.9915ZM53.7219 7.3892V6.00852C53.7219 4.91761 53.9563 3.92045 54.4251 3.01705C54.9023 2.10511 55.5842 1.37642 56.4705 0.830965C57.3569 0.276988 58.4308 0 59.6921 0C60.9961 0 62.0913 0.276988 62.9776 0.830965C63.8725 1.37642 64.5501 2.10511 65.0103 3.01705C65.4705 3.92045 65.7006 4.91761 65.7006 6.00852V7.3892C65.7006 8.48011 65.4663 9.47727 64.9975 10.3807C64.5373 11.2841 63.8597 12.0043 62.9648 12.5412C62.07 13.0781 60.979 13.3466 59.6921 13.3466C58.4052 13.3466 57.3143 13.0739 56.4194 12.5284C55.533 11.983 54.8597 11.2585 54.3995 10.3551C53.9478 9.45171 53.7219 8.46307 53.7219 7.3892ZM57.8384 6.00852V7.3892C57.8384 7.96023 57.9705 8.4929 58.2347 8.98722C58.5075 9.47301 58.9933 9.71591 59.6921 9.71591C60.4421 9.71591 60.9407 9.47301 61.1879 8.98722C61.4435 8.4929 61.5714 7.96023 61.5714 7.3892V6.00852C61.5714 5.4375 61.4521 4.90057 61.2134 4.39773C60.9748 3.88636 60.4677 3.63068 59.6921 3.63068C58.9762 3.63068 58.4861 3.89062 58.2219 4.41051C57.9663 4.9304 57.8384 5.46307 57.8384 6.00852ZM55.6523 27.2812L73.6523 1.09943H77.1424L59.1424 27.2812H55.6523Z",
    fill: "var(--fill-0, white)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_5",
    filter: "url(#filter4_d_0_76)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.44 27.9205C33.1559 27.9205 31.1871 27.3793 29.5337 26.2969C27.8803 25.206 26.6062 23.642 25.7113 21.6051C24.8164 19.5597 24.3732 17.1009 24.3817 14.2287C24.3903 11.3565 24.8377 8.91904 25.7241 6.91619C26.619 4.90483 27.8888 3.375 29.5337 2.32671C31.1871 1.26989 33.1559 0.741478 35.44 0.741478C37.7241 0.741478 39.6928 1.26989 41.3462 2.32671C43.0082 3.375 44.2866 4.90483 45.1815 6.91619C46.0763 8.92756 46.5195 11.3651 46.511 14.2287C46.511 17.1094 46.0636 19.5724 45.1687 21.6179C44.2738 23.6634 42.9996 25.2273 41.3462 26.3097C39.7013 27.3835 37.7326 27.9205 35.44 27.9205ZM35.44 22.7429C36.8036 22.7429 37.9073 22.0483 38.7511 20.6591C39.5948 19.2614 40.0124 17.1179 40.0039 14.2287C40.0039 12.3366 39.8121 10.777 39.4286 9.54972C39.0451 8.31392 38.5124 7.39347 37.8306 6.78835C37.1488 6.18324 36.3519 5.88068 35.44 5.88068C34.0849 5.88068 32.9897 6.56676 32.1545 7.93892C31.3192 9.30256 30.8974 11.3991 30.8888 14.2287C30.8803 16.1463 31.0636 17.7358 31.4386 18.9972C31.8221 20.2585 32.359 21.2003 33.0494 21.8224C33.7397 22.4361 34.5366 22.7429 35.44 22.7429Z",
    fill: "var(--fill-0, white)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_6",
    filter: "url(#filter5_d_0_76)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3239 1.09943V27.2812H10.0085V7.00568H9.85511L4 10.5852V5.11364L10.456 1.09943H16.3239Z",
    fill: "var(--fill-0, white)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_76",
    x: 56.9306,
    y: 45.0994,
    width: 25.8722,
    height: 34.1818,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_76"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_76",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_0_76",
    x: 33.372,
    y: 45.0994,
    width: 25.8722,
    height: 34.1818,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_76"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_76",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_0_76",
    x: 2.18448,
    y: 44.7415,
    width: 32.9929,
    height: 34.8977,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_76"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_76",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_0_76",
    x: 49.7219,
    y: 0,
    width: 33.5426,
    height: 36.3807,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_76"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_76",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_0_76",
    x: 20.3816,
    y: 0.741478,
    width: 30.1295,
    height: 35.179,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_76"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_76",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_0_76",
    x: 0,
    y: 1.09943,
    width: 20.3239,
    height: 34.1818,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_76"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_76",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountTenOff);
export default __webpack_public_path__ + "static/media/discount-ten-off.7db483a8a53f3a3deae7fad980415e41.svg";
export { ForwardRef as ReactComponent };